import axios from "axios";
import { getItem, setAuthData } from "./LocalStorageManager";
import { jwtDecode } from 'jwt-decode';
import UrlBase from "../urls/Urls.js";

/**
 * Axion public 
 */
const publicFetch = axios.create({
  baseURL: UrlBase.base_url
});

/**
 * Axion private - internal endpoints 
 */
const privateFetch = axios.create({
  baseURL: UrlBase.base_url
});

/**
 * Axion private - interceptors
 */
privateFetch.interceptors.request.use(
  async (config) => {
    // validate uri to send token
    const { origin } = new URL(config.baseURL + config.url);
    const allowedOrigins = [new URL(UrlBase.base_url).origin];
    const authInfo = await getItem("authAdminInfo");
    
    const decodeToken = jwtDecode(authInfo?.tokenInfo?.access_token);

    const expiresAt = decodeToken.exp;
    let valid = new Date().getTime() / 1000 < expiresAt;
    if (allowedOrigins.includes(origin) && valid) {
      config.headers.Authorization = `Bearer ${authInfo?.tokenInfo?.access_token}`;
    }
    return config;
  }
);

/**
 * Axion private - el gateway rechaza tokens invalidos, vencidos o de usuarios
 * inactivos con code CRM_AUTH: se limpia la sesion local y se vuelve al login.
 */
privateFetch.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401 && error.response.data?.code === "CRM_AUTH") {
      await setAuthData("authAdminInfo", null);
      if (window.self === window.top) {
        window.location.assign("/");
      }
    }
    return Promise.reject(error);
  }
);

export { publicFetch, privateFetch};
